import React, { useMemo, useState, useEffect, useReducer } from "react";
import { Edit } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import api from "../../../../_core/api";
import * as S from "../styles";
import { Button, Table, Modal } from "../../../../_core/_components";
import { handleErrors, success } from "../../../../_core/services/toast";
import { FullScreenLoading } from "../../../../_core/_components/fullscreen-loading";
import { INITIAL_STATE, reducer } from "./reducer";
import ModalContent from "./modal-content";

export const TipoComunicado: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tipoComunicadoList, setTipoComunicadoList] = useState<any[]>([]);
  const [form, dispatch] = useReducer(reducer, undefined);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.post(`/api/cartas/tipoComunicado/buscar`, {
        nomeTipoComunicado: "",
        codigoTipoComunicado: "",
      });
      setTipoComunicadoList(data.content);
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const onClickSave = async () => {
    try {
      setIsLoading(true);
      await api.post(`/api/cartas/tipoComunicado/salvar`, form);
      dispatch({ type: "UNSET_TIPO_COMUNICADO" });
      const { data } = await api.post(`/api/cartas/tipoComunicado/buscar`, {
        nomeTipoComunicado: "",
        codigoTipoComunicado: "",
      });
      setTipoComunicadoList(data.content);
      success("Tipo Comunicado salvo com sucesso.");
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const data = useMemo(() => {
    return tipoComunicadoList.map((e) => ({
      ...e,
      ativoStr: e.flagAtivo ? "Sim" : "Não",
      editar: (
        <IconButton
          onClick={() =>
            dispatch({
              type: "SET_TIPO_COMUNICADO",
              payload: {
                ...e,
              },
            })
          }
        >
          <Edit />
        </IconButton>
      ),
    }));
  }, [tipoComunicadoList]);

  return (
    <>
      {form && (
        <Modal
          title="Adicionar / Alterar Tipo Comunicado"
          onClose={() => dispatch({ type: "UNSET_TIPO_COMUNICADO" })}
          content={<ModalContent form={form} dispatch={dispatch} />}
          actionItems={[<Button onClick={onClickSave} text="Salvar" />]}
        />
      )}
      <FullScreenLoading isEnabled={isLoading} />
      <S.DataContainer>
        <S.TopBar>
          <S.SearchBar></S.SearchBar>
          <Button
            text="Novo"
            onClick={() =>
              dispatch({ type: "SET_TIPO_COMUNICADO", payload: INITIAL_STATE })
            }
            styles={{ width: 100 }}
          />
        </S.TopBar>
        {tipoComunicadoList.length > 0 && (
          <Table
            columns={[
              { label: "Nome", key: "nomeTipoComunicado" },
              { label: "Ativo", key: "ativoStr" },
              { label: "Editar", key: "editar" },
            ]}
            data={data}
          />
        )}
      </S.DataContainer>
    </>
  );
};
